import React from "react";
import { Screens, AssessmentState } from "../../../../services/assessment-state/types";
// import { useSuburbName } from "../../../../utils";
import AboutData from "../About";
import AgeData from "../Age";
import * as GenderIdentity from "../GenderIdentity";
import { Intro } from "../Intro";
import { Results } from "../Results";
import SelectSuburbData from "../SelectSuburb";
import * as SupportRequirements from "../SupportRequirements";
import * as WhoFor from "../WhoFor";

interface Meta {
    title: string;
    canProgress: boolean;
    canSkip: boolean;
}

type CreateMeta = (state: AssessmentState) => Meta;

interface Api {
    rendered: React.ReactNode;
    createMeta: CreateMeta;
}

export const createScreenMapping = (): Record<Screens, Api> => ({
    [Screens.Intro]: {
        rendered: <Intro />,
        createMeta: () => ({ title: "", canProgress: false, canSkip: false }),
    },
    [Screens.SelectSuburb]: {
        rendered: <SelectSuburbData.Component />,
        createMeta: SelectSuburbData.createMeta,
    },
    [Screens.WhoFor]: {
        rendered: <WhoFor.WhoFor />,
        createMeta: WhoFor.createMeta,
    },
    [Screens.Age]: {
        rendered: <AgeData.Component />,
        createMeta: AgeData.createMeta,
    },
    [Screens.About]: {
        rendered: <AboutData.Component />,
        createMeta: AboutData.createMeta,
    },
    [Screens.Results]: {
        rendered: <Results />,
        createMeta: () => ({ title: "", canProgress: false, canSkip: false }),
    },
    [Screens.GenderExpression]: {
        rendered: <GenderIdentity.GenderIdentity />,
        createMeta: GenderIdentity.createMeta,
    },
    [Screens.SupportRequirements]: {
        rendered: <SupportRequirements.SupportRequirements />,
        createMeta: SupportRequirements.createMeta,
    },
});
